import { getBrandValue } from "../brand/selectors";
import { ssoToOldOnlineURL } from "../../ui/utils/location";
import { getUser } from "../user/selectors";

const ssoNewWindow = (brandItem, defaultVal) => {
  return (dispatch, getState) => {
    const url = getBrandValue(getState(), brandItem, defaultVal);
    const user = getUser(getState());
    ssoToOldOnlineURL(url, true, user);
  };
};

export const goToTeacherPortal = () => {
  return dispatch => {
    dispatch(
      ssoNewWindow(
        "TeacherPortal.url",
        "https://bookshelf-teacher.vitalsource.com/"
      )
    );
  };
};

export const goToStore = () => {
  return dispatch => {
    dispatch(
      ssoNewWindow(
        "Store.url",
        "https://stargate-dev.gc.vitalbook.com?utm_source=bookshelfonline&utm_medium=bookshelf"
      )
    );
  };
};
